export const TAB_KEY = 'Tab';
export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const SPACE_KEY = ' ';
export const LEFT_KEY = 'ArrowLeft';
export const UP_KEY = 'ArrowUp';
export const RIGHT_KEY = 'ArrowRight';
export const DOWN_KEY = 'ArrowDown';

// Height of the input field minus the margin
export const SUGGESTION_CARD_Y_POS = 32 - 4;

export const hasSpaceRegEx = /\s/;
export const hasSpacesAroundRegEx = /^\s|\s$/;
export const hasStartingQuotesRegex = /^('|")/;
export const hasEndingQuotesRegex = /('|")$/;
export const hasNewLinesRegex = /(\r\n|\n|\r)/gm;
// minimally ensure email has format of _@_._
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const hasColonRegex = /:/;
